import React from 'react';

import { ReactFCV } from '@types';

import { IGift } from '../../../model';
import { GiftItem } from '../GiftItem';
import { EGiftListItemType } from '../model';

import { StyledCheckbox, StyledRadioButton } from './styled';

interface IGiftListItem {
  type: EGiftListItemType;
  gift: IGift;
  disabled: boolean;
  onChange: () => void;
}

export const GiftListItem: ReactFCV<IGiftListItem> = ({ type, gift, disabled, onChange }) =>
  type === EGiftListItemType.CheckBox ? (
    <StyledCheckbox onChange={onChange} disabled={disabled} checked={gift.selected} position={13}>
      <GiftItem imageUrl={gift.image} brand={gift.brand} collection={gift.collection} subName={gift.subName} />
    </StyledCheckbox>
  ) : (
    <StyledRadioButton onChange={onChange} disabled={disabled} checked={gift.selected} position={13}>
      <GiftItem imageUrl={gift.image} brand={gift.brand} collection={gift.collection} subName={gift.subName} />
    </StyledRadioButton>
  );
